import React from "react";
import "./style.css";

export const CourseLandingQuote = ({title, artist}) => {
  return (
    <div className="course_landing_quote">
      <div className="course_landing_quote_title">
        “{title}”
      </div>
      <div className="course_landing_quote_artist">
        {artist}
      </div>
    </div>
  );
};
